import {BackendApi} from '@/services/backend_api'

export default {
  get (uuid, parkId) {
    return BackendApi.getClient().get(`quiz-templates/${uuid}/${parkId}`)
      .then(response => { return response })
      .catch(e => { throw e })
  }
}



// WEBPACK FOOTER //
// ./src/services/resource_client/quiz_template.js